<template lang="pug">
.container
  h4.normal {{ $t('You are going to move ') }}
    span.warning {{ medium.name }}
    span {{ $t(' and it`s children to production root folder') }}
  hr.header
  .section(v-if='children.length > 0', v-for='child of children', :key='child.PlayListItemId')
    .row
      p {{ child.mediumname }}
  hr.header(v-if='children.length > 0')
  el-button.float-right(id="UntestMedium-button" v-if='medium.test && !$store.state.User.user.test', @click='untest()', type="success", size="small", :title="$t('Untest')", :disabled='saving')
    font-awesome-icon(icon="unlock")
    span &nbsp; {{ !saving ? $t('Un-test medium') : $t('untesting...') }}
</template>

<script>

import Vue from 'vue'

export default {
  props: ['medium'],
  mixins: [],
  components: {
  },
  async created () {
    if (this.medium.type.indexOf('PlayList') > -1) {
      this.children = await Vue.axios.post(`medium/preparePlaylistContentFlat`, { PlayList: this.medium.id }).then((response) => { return response.data.rows })
    }
  },
  data () {
    return {
      errors: [],
      children: [],
      saving: false
    }
  },
  methods: {
    async untest () {
      this.saving = true
      await Vue.axios.post(`medium/untestMedia`, { children: this.children, parentPlaylistId: this.medium.id })
      this.saving = false
      this.$emit('close-untestMedium')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.normal {
  font-weight: 100;
  .warning {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/UntestMedium.vue